<script>
export default {
  name: "BreadCrum",
}
</script>
<template>
    <div class="bg-indigo-600 p-1 mt-5 mb-5 text-xs text-white">
       <nav class="bg-grey-light rounded font-sans w-full p-1">
         <ol class="list-reset flex text-grey-dark">
           <li><router-link :to="{name : 'home'}">Home</router-link></li>
           <li><span class="mx-2">/</span></li>
           <slot>
             
           </slot>
         </ol>
       </nav>
    </div>
</template>
